<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
import { on, off } from 'iview/src/utils/dom';
import { setMatchMedia } from 'iview/src/utils/assist';

import { mapMutations } from 'vuex';

setMatchMedia();
export default {
    name: "App",
  provide() {
    return {
      reload: this.reload,
      url:'',
      appType:process.env.VUE_APP_TYPE
    };
  },
  beforeCreate(){
      var url=window.location.href.split("/")[0]+'//'+window.location.href.split("/")[2]
      this.url = url
      console.log(this.url,'this.url------app.vue---------------')
  },
  methods: {
    // this.appType = process.env.VUE_APP_TYPE // (全局的动态变量)
    // 根据不同appType来显示不同的.ico文件
    // 修改favicon文件
    changeFavicon() {
      let favicon = document.querySelector('link[rel="icon"]')
      // console.log('app', favicon)
      if (favicon !== null) {
        if(this.url=='https://mall-admin.cellprobio.com'){
          favicon.href = 'https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/skyd/sp_favicon.jpg'
        }else{
          favicon.href = '/static/favicon.png'
        }
      }
    },
    ...mapMutations('media', ['setDevice']),
    handleWindowResize() {
      this.handleMatchMedia();
    },
    handleMatchMedia() {
      const matchMedia = window.matchMedia;

      if (matchMedia('(max-width: 600px)').matches) {
        var deviceWidth = document.documentElement.clientWidth || window.innerWidth;
        let css = 'calc(100vw/7.5)';
        document.documentElement.style.fontSize = css;
        this.setDevice('Mobile');
      } else if (matchMedia('(max-width: 992px)').matches) {
        this.setDevice('Tablet');
      } else {
        this.setDevice('Desktop');
      }
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
  mounted() {
    on(window, 'resize', this.handleWindowResize);
    this.handleMatchMedia();
    this.changeFavicon()
  },
  beforeDestroy() {
    off(window, 'resize', this.handleWindowResize);
  },
};
</script>
<!-- scoped -->
<style lang="stylus" >
//@import './assets/style/public.styl';
</style>
<style>
body {
    background: #eff0f5 ;
    color: #232323;
}
.fontColor {
    width: 140px;
    text-align: right;
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    padding-right: 5px;
}
/* .context_div{
  background: #ecf5ff !important;
} */
.form {
    padding: 10px 0;
    margin: 0 auto;
}

.basicNewsTwo{
    overflow: hidden !important ;
    text-overflow: ellipsis !important ;
    display: -webkit-box !important ;
    -webkit-line-clamp: 1 !important ;
    -webkit-box-orient: vertical !important ;
}
.el-dialog .el-dialog__title{
    text-align:center;
    line-height:30px;
}
.el-dialog {
    border-radius: 20px;
}
.el-icon-circle-close:before {
    content: "\E78D";
    color: #999;
}
.el-radio__input.is-checked + .el-radio__label {
    color: #3c6cfe !important;
}
.el-radio__input.is-checked .el-radio__inner {
    background: #3c6cfe !important;
    border-color: #3c6cfe !important;
}
/* el-checkbox 改样式 */
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: #3c6cfe !important;
  background-color: #3c6cfe !important;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #606266;
}
/*.el-button--warning {*/
/*    padding: 7px 15px;*/
/*    margin-bottom: 10px;*/
/*    font-size: 14px;*/
/*}*/
.el-link.el-link--default {
    color: #3c6cfe !important;
}
.el-link.el-link--primary {
    color: #3c6cfe;
}
/* 分页样式 */
.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #3c6cfe;
    color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue